import React, { cloneElement } from 'react';
import useTheme from 'branding/theme';
import useComponentMargin from '../../hooks/useComponentMargin';
import Label from '../../typography/Label';
import AlertIcon from '../../icons/utility/AlertIcon';
import InputError from '../../inputs/InputError';
export const Input = React.forwardRef(({ name, displayName, required = false, size = 'large', disabled = false, error = false, errorMessage, children, isFocus = false, placeholder }, ref) => {
    const { borders, sizing: { widths }, inputs: { base, shape, size: sizeStyles, disabled: disabledInputStyles, utilityIconStyles }, utility: { size: { fullWidthStyles } }, colors } = useTheme();
    const marginStyles = useComponentMargin({
        marginVertical: 'small',
        ...(!error && { marginBottom: 'regular' })
    });
    const mergedStyles = {
        ...base,
        ...shape.pill,
        ...sizeStyles.regular,
        ...fullWidthStyles,
        ...(disabled && disabledInputStyles),
        ...(!isFocus && borders.variant.secondary),
        // error styles MUST come after active styles to override them
        ...(!!error && borders.error),
        ...marginStyles
    };
    const wrapperStyles = {
        width: widths.input[size],
        position: 'relative'
    };
    const options = {
        style: {
            base: {
                fontFamily: base.fontFamily,
                lineHeight: '48px',
                fontSize: '16px',
                color: colors.neutrals.textAlpha,
                fontWeight: base.fontWeight,
                '::placeholder': {
                    color: colors.neutrals.textGamma
                }
            },
            invalid: {
                color: colors.status.fail.alpha
            }
        },
        placeholder: placeholder
    };
    return (React.createElement("div", { ref: ref, style: wrapperStyles },
        React.createElement(Label, { htmlFor: name, required: required }, displayName),
        React.createElement("div", { style: mergedStyles }, cloneElement(children, { options })),
        error && React.createElement(AlertIcon, { size: "utility", styles: utilityIconStyles }),
        error && errorMessage && React.createElement(InputError, { id: errorMessage }, errorMessage)));
});
export default Input;
//# sourceMappingURL=index.js.map